import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 8v8","key":"svg-0"}]]

const IconLetterISmall = createReactComponent('outline', 'letter-i-small', 'LetterISmall', __iconNode);

export default IconLetterISmall;